import { ArchivedDocumentWithDetails, VisibleColumnSpec } from "@/types";

export const ORDER_DRAWER_DOCUMENTS_COLUMN: VisibleColumnSpec<
  ArchivedDocumentWithDetails,
  "checkbox" | "actions" | "size"
>[] = [
  "checkbox",
  "fileName",
  "documentType",
  "fileType",
  "createdTime",
  // { id: "size", breakpoint: "mantine-visible-from-sm" },
  // "actions",
];
